
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/jobs/investment-banking/[slug]",
      function () {
        return require("private-next-pages/jobs/investment-banking/[slug].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/jobs/investment-banking/[slug]"])
      });
    }
  